export function getFileExtensionFromName(name) {
    if (!name) {
        return '';
    }
    var lastIndexOfPeriod = name.lastIndexOf('.');
    if (lastIndexOfPeriod === -1) {
        return '';
    }
    return name.substring(lastIndexOfPeriod + 1);
}
//# sourceMappingURL=getFileExtensionFromName.js.map